import request from "../request";
import { WS_TRUCK } from "./prefix";

/**
 * @desc 提交系统问题
 */
export const apiPostProblemfeedback = (data = {}): any => {
  return request({
    url: `/api${WS_TRUCK}/systemIssueFeedback/submit`,
    method: "post",
    data,
  }).then((res) => res.data);
};
